import './Header.scss'

import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import Logo from './Logo'
import UserImpersonationWrapper from './UserImpersonationWrapper'

const Header = ({className, children, userInfo, localize}) => {
  const {isImpersonation} = userInfo
  return (
    <Fragment>
      <UserImpersonationWrapper localize={localize} userInfo={userInfo}/>
      <div className='daptiv-header'>

        <div className={`app-header ${className} header-container`}>
          <Logo />
          <div className={'header-right-container'}>
            {children}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

Header.defaultProps = {
  userInfo: {},
}

Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  userInfo: PropTypes.object,
  localize: PropTypes.func,
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js